import { EventsRepository } from '@lib/api/repository/events/events.repository';
import { EventsUseCase } from '@lib/interfaces/usecase/events.use-case';
import {
  AssignEventOrganizerInput,
  EventBannerInput,
  EventFilters,
  EventInput,
  OrganizerSearch,
  TransitionEventInput,
  UpdateEventInput,
} from '@lib/types/event';

export default class EventsService implements EventsUseCase {
  constructor(private repository: EventsRepository) {}
  list(filters: EventFilters, admin: boolean, signal?: AbortSignal) {
    return this.repository.list(filters, admin, signal);
  }

  find(identifier: string, admin: boolean, signal?: AbortSignal, viewer?: boolean) {
    return this.repository.find(identifier, admin, signal, viewer);
  }

  findEditable(id: string, signal?: AbortSignal) {
    return this.repository.findEditable(id, signal);
  }

  searchOrganizers(filters: OrganizerSearch, signal?: AbortSignal) {
    return this.repository.searchOrganizers(filters, signal);
  }

  assignOrganizer(input: AssignEventOrganizerInput) {
    return this.repository.assignOrganizer(input);
  }

  create(input: EventInput) {
    return this.repository.create(input);
  }

  update(input: UpdateEventInput) {
    return this.repository.update(input);
  }

  transition(input: TransitionEventInput) {
    return this.repository.transition(input);
  }

  uploadBanner(input: EventBannerInput) {
    return this.repository.uploadBanner(input);
  }
}
